import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByCategory'
})
export class groupByCategoryPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return value.reduce(function (rv, x) {
        let index = rv.findIndex(e => e.category == x.categoryName);
        if (index > -1) {
          rv[index].elements.push(x);
          if(x.checked){
            rv[index].optChecked++;
            rv[index].suppChecked++;
          }
        } else {
          let item:any = {
            category: x.categoryName,
            categoryId: x.category,
            elements: [x]
          }
          if(x.nbrSuppOfferts){
            item.nbrSuppOfferts=Number(x.nbrSuppOfferts)
          }
          if(x.comment){
            item.comment=x.comment
          }
          if(x.minNbrIngOptions){
            item.minNbrIngOptions=Number(x.minNbrIngOptions)
          }
          if(x.maxNbrIngOptions){
            item.maxNbrIngOptions=Number(x.maxNbrIngOptions)
          }
          item.optChecked=0;
          item.suppChecked=0;
          if(x.checked){
            item.optChecked=1;
            item.suppChecked=1;
          }
          rv.push(item)
        }
        return rv;
      }, []);
    }
    return null;
  }

}
